<p-contextMenu #gf appendTo="body" [model]="items"></p-contextMenu>

<div class="task-board-container" #boardContainer>
  <!-- Global Loading Overlay -->
  @if (loading) {
    <div class="board-loading-overlay">
      <div class="loading-content">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        <p>Loading boards...</p>
      </div>
    </div>
  }

  <div class="board-columns">
    @for (columnKey of getColumnKeys(); track columnKey) {
      <div class="board-column"
        [attr.data-column-key]="columnKey">
        <div class="column-header">
          <h3 class="column-title">{{ getColumnName(columnKey) }}</h3>
          <span class="column-count">{{ getTasksForColumn(columnKey).length }}</span>
        </div>
        <div class="column-content"
          [attr.data-key]="columnKey"
          (scroll)="onColumnScroll($event, columnKey)">
          <!-- Add Task Button - Sticky at top -->
          <div class="add-task-btn add-task-btn-sticky"
            (click)="onAddTaskClick(columnKey, $event)">
            <i class="pi pi-plus"></i>
            <span>Add Task</span>
          </div>
          <!-- Column Loading State -->
          @if (getColumnLoadingState(columnKey) && getTasksForColumn(columnKey).length === 0) {
            <div class="loading-indicator">
              <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem; color: #3b82f6;"></i>
              <p class="loading-text">Loading tasks...</p>
            </div>
          }
          <!-- Empty State - Show when column has no tasks and not loading -->
          @if (!getColumnLoadingState(columnKey) && getTasksForColumn(columnKey).length === 0 && allLoadedTasks.length > 0) {
            <div class="empty-state">
              <div class="empty-state-content">
                <i class="pi pi-inbox"></i>
                <p>No tasks in this column</p>
              </div>
            </div>
          }
          <!-- Empty State - Show when no tasks loaded at all -->
          @if (!getColumnLoadingState(columnKey) && getTasksForColumn(columnKey).length === 0 && allLoadedTasks.length === 0) {
            <div class="empty-state">
              <div class="empty-state-content">
                <i class="pi pi-inbox"></i>
                <p>No tasks found</p>
                <span class="empty-state-hint">Try adjusting your filters or create a new task</span>
              </div>
            </div>
          }
          <!-- Task Cards -->
          @for (task of getTasksForColumn(columnKey); track task) {
            <div class="task-card"
              [style.border-left-color]="getTaskColor(task)"
              [class.subtask-card]="isSubTask(task)"
              (click)="onTaskClick(task, $event)"
              (dblclick)="onTaskDoubleClick(task, $event)"
              (contextmenu)="openCm($event, gf, task)">
              <div class="task-card-header">
                <span>
                  <span (click)="openCm($event, gf, task)"><i class="pi pi-align-justify" aria-hidden="true"
                  style="margin-left: 5px"></i></span>
                </span>
                <span class="task-id">
                  @if (isSubTask(task)) {
                    <i class="pi pi-sitemap subtask-icon" title="Sub-task"></i>
                  }
                  #{{ task.taskId }}
                </span>
                @if (task?.priority) {
                  <span class="task-priority">
                    <i class="pi pi-flag" [class]="'priority-' + task?.priority"></i>
                  </span>
                }
              </div>
              <div class="task-card-body">
                <p class="task-name">{{ task.name }}</p>
                @if (isSubTask(task) && getParentTaskDisplayName(task)) {
                  <span class="parent-task-indicator clickable"
                    (click)="onParentTaskClick(task, $event)"
                    [title]="'Click to open parent task'">
                    <i class="pi pi-arrow-up"></i>
                    {{ getParentTaskDisplayName(task) }}
                  </span>
                }
              </div>
              <div class="task-card-footer">
                @if (task.assignedTo) {
                  <span class="task-assignee">
                    <i class="pi pi-user"></i>
                    {{ fullName(task.assignedTo) }}
                  </span>
                }
                @if (task.dateDue) {
                  <span class="task-due-date">
                    <i class="pi pi-calendar"></i>
                    {{ task.dateDue | date:'shortDate' }}
                  </span>
                }
              </div>
            </div>
          }
          <!-- Loading More Indicator -->
          @if (getColumnLoadingState(columnKey) && getTasksForColumn(columnKey).length > 0) {
            <div class="loading-indicator">
              <i class="pi pi-spin pi-spinner" style="font-size: 1rem; color: #3b82f6;"></i>
              <p class="loading-text">Loading more tasks...</p>
            </div>
          }
          <!-- No More Tasks Message - Creative -->
          @if (getColumnAllTasksLoaded(columnKey) && getTasksForColumn(columnKey).length > 0) {
            <div class="no-more-tasks">
              <div class="no-more-tasks-content">🎉 <i class="pi pi-check-circle" style="display: inline; margin: 0 0.25rem;"></i> All caught up!</div>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <p-contextMenu #gf appendTo="body" [model]="items"></p-contextMenu>
</div>

<p-dialog header="Summary" [(visible)]="showOpenSummary" [style]="{width: '30vw'}">
  @if (taskApiData) {
    <app-task-summary [task]="taskApiData"></app-task-summary>
  }
</p-dialog>

